import { inject } from '@angular/core';
import { FormMediator } from '@core/data-access/services/form/form-mediator.service';
import { AnonymousVoucherActions } from '@core/data-access/store/shared/shared.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { TariffPersonalizationType } from '@products/models/tariff.model';
import { getBookedVoucherTariffByVoucherCode } from '@store/products/booking/product/voucher/voucher-booking.selectors';
import { VoucherProductActions } from '@store/products/product.actions';
import { filter, map, tap } from 'rxjs';

export * from '@core/data-access/store/shared/effects/ticket-sending-option.effects';

export const anonymousVoucherIsReleased$ = createEffect(
  (actions$ = inject(Actions), store = inject(Store)) =>
    actions$.pipe(
      ofType(VoucherProductActions.releaseVoucher, VoucherProductActions.releaseExpiredVoucher),
      concatLatestFrom(({ voucherCode }) => store.select(getBookedVoucherTariffByVoucherCode(voucherCode))),
      filter(
        ([_, voucherBookedTariff]) => voucherBookedTariff?.personalizationType === TariffPersonalizationType.Anonymous
      ),
      map(() => AnonymousVoucherActions.anonymousVoucherIsReleased())
    ),
  { functional: true }
);

export const resetStateOnAnonymousVoucherRedeem$ = createEffect(
  (actions$ = inject(Actions), formMediator = inject(FormMediator)) =>
    actions$.pipe(
      ofType(VoucherProductActions.setRedeemedAndReleaseVouchersInProductBookingsAndProductSelection),
      filter(({ redeemedVoucher }) => redeemedVoucher?.isAnonymous),
      tap(() => formMediator.resetFormStates([])),
      map(() => AnonymousVoucherActions.resetStateOnAnonymousVoucherRedeem())
    ),
  { functional: true }
);
